import { get, post } from "./base";

export async function getUserInfo() {
    let respObj = await get("/edu-classroom/user/current-user-info");
    return respObj;
}

export async function updateUserInfo(params) {
    let respObj = await post("/edu-classroom/user/update", params);
    return respObj;
}